// This file was auto-generated by Fern from our API Definition.
/**
 * Who initiated the transfer — and therefore where the row sorts.
 *
 * Declared oldest-first: PULLED rows predate every PUSHED row, so
 * `ORDER BY origin, id` is the log's true sequence.
 */
export const ChannelEventOrigin = {
    Pulled: "pulled",
    Pushed: "pushed",
};
